<template>
    <v-hover #default="{ hover }">
        <v-card max-width="450" :elevation="hover ? 16 : 2">
            <v-img class="white--text align-end"
                :src="artist.image"
                :alt="artist.firstname"
                :title="artist.firstname">
                <v-card-title class="jazz-artist-header">
                    {{ artist.firstname }} {{ artist.name }}
                    <br />
                    <small>{{ artist.header }}</small>
                </v-card-title>
            </v-img>
            <v-card-text>
                {{ artist.content }}
            </v-card-text>
        </v-card>
    </v-hover>
</template>

<script>
export default {
    name: 'jazz-artist',
    props: {
        artist: { type: Object, required: true }
    }
}
</script>

<style>
.jazz-artist-header {
    background-color: rgba(0, 0, 0, 0.3);
}

.jazz-artist-header small {
    word-break: normal;
}
</style>
